import store from "../app/store";
import {createAction} from "@reduxjs/toolkit";
import {ACTION_BREADCRUMBS_CHANGED, ACTION_SET_PAGE_TITLE} from "./LayoutReducer";

export function setPageTitle(title) {
    store.dispatch(createAction(ACTION_SET_PAGE_TITLE)({pageTitle: title}));
}

export function setBreadcrumbs(breadcrumbs) {
    store.dispatch(createAction(ACTION_BREADCRUMBS_CHANGED)({breadcrumbs: breadcrumbs}));
}